
import { doc, getDoc, setDoc, onSnapshot } from 'firebase/firestore';
import { db } from './firebase';
import { SystemConfig } from '../types';
import { useState, useEffect } from 'react';

const CONFIG_DOC_PATH = 'system/config'; // Collection: system, Doc: config

export const DEFAULT_CONFIG: SystemConfig = {
    commissionRates: {
        default: 0.10, // Toplam oran (legacy)
        buyer: 0.05,
        seller: 0.10,
        referral: 0.02,
        electronics: 0.05,
        clothing: 0.15
    },
    dopingRates: {
        day1: { base: 10, percentage: 0.01 },
        day3: { base: 25, percentage: 0.03 },
        day7: { base: 50, percentage: 0.05 }
    },
    boostStats: {
        riskFreeRate: 0.20, // +20% markup on Doping Price (Risk Fee)
    }
};

// Hook for React Components (Real-time)
export const useSystemConfig = () => {
    const [config, setConfig] = useState<SystemConfig>(DEFAULT_CONFIG);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsub = onSnapshot(doc(db, CONFIG_DOC_PATH), (snap) => {
            if (snap.exists()) {
                setConfig(snap.data() as SystemConfig);
            } else {
                // Initialize default if missing
                setDoc(doc(db, CONFIG_DOC_PATH), DEFAULT_CONFIG);
            }
            setLoading(false);
        });

        return () => unsub();
    }, []);

    return { config, loading };
};

// Helper for one-off fetches (Cloud Functions / Logic)
export const getSystemConfig = async (): Promise<SystemConfig> => {
    try {
        const snap = await getDoc(doc(db, CONFIG_DOC_PATH));
        if (snap.exists()) return snap.data() as SystemConfig;
        return DEFAULT_CONFIG;
    } catch (e) {
        console.error("Config fetch failed:", e);
        return DEFAULT_CONFIG;
    }
};

export const updateSystemConfig = async (newConfig: SystemConfig) => {
    await setDoc(doc(db, CONFIG_DOC_PATH), newConfig, { merge: true });
};
